export default __webpack_public_path__ + "static/media/330_dummy2016-beauty01-mobile-de.4d429cca.png";